import { render, staticRenderFns } from "./LegalEntityContact.vue?vue&type=template&id=321a662b&scoped=true"
import script from "./LegalEntityContact.vue?vue&type=script&lang=js"
export * from "./LegalEntityContact.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityContact.vue?vue&type=style&index=0&id=321a662b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a662b",
  null
  
)

export default component.exports